import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PLATFORM_API_URL, DOCUMENT_API_URL } from '@app/core/constants';
import { UploadFromContainer } from '@app/core/model';
import { ProductWithLoBAndTenantDTO } from '@app/shared/models/product-lob-tenant.model';
import { Observable } from 'rxjs';

@Injectable()
export class AttachToAuthorizationApiService {

  constructor(
    public http: HttpClient,
    @Inject(PLATFORM_API_URL) private readonly platform_api_url: string,
    @Inject(DOCUMENT_API_URL) private readonly document_api_url: string
  ) { }

  getAuthorizationContext(memberTenantId: string, memberLobId: string, authNumber: string): Observable<ProductWithLoBAndTenantDTO> {
    const url = `${this.getBaseUrl()}/Authorizations/GetAuthorizationContext/tenant/${memberTenantId}/memberlobid/${memberLobId}/authorization/${authNumber}`;
    return this.http.get<ProductWithLoBAndTenantDTO>(url);
  }

  isValidAuthorization(authNumber: string, tenantLobProductId: string, memberId: string): Observable<boolean> {
    const url = `${this.getBaseUrl()}/Authorizations/ExistsForMember/tenantLobProduct/${tenantLobProductId}/member/${memberId}/authorization/${authNumber}`;
    return this.http.get<boolean>(url);
  }

  attachFileToAuth(uploadFromContainer: UploadFromContainer): Observable<boolean> {
    const url = `${this.getDocumentBaseUrl()}/ContainerFile/UploadFileFromContainer`;
    return this.http.post<boolean>(url, uploadFromContainer);
  }

  protected getBaseUrl(): string {
    return `${this.platform_api_url}/api`;
  }
  
  protected getDocumentBaseUrl(): string {
    return `${this.document_api_url}/api`;
  }
}
